// extracted by css-extract-rspack-plugin
export default {"footer":"StepsFooter-module__footer--Obyhk","step":"StepsFooter-module__step--sgzMX","active":"StepsFooter-module__active--TSyEX"};